// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useConfigValidation } from '../../helpers';
import {
  showValidationErrors,
  hideValidationErrors,
} from '../../store/uiStore/validation';
import { anyChoiceGroupHasError } from '../../store/configuration/actives';
import type { FixMe } from '../../types/any';
import scrollToAnchor from '../../helpers/scrollToAnchor';
import { ERROR_ID } from '../config/atoms/choiceGroups/claimfree';

/**
 * onClick:
 * if valid: continue & hide errors
 * if invalid: preventDefault/onClick & display errors
 * The wrappedComponent should pass down an 'onClick' prop
 */

// @TODO: create HoC typing https://justlease.atlassian.net/browse/LISTO-307
const withOnClickValidation = (WrappedComponent: FixMe): FixMe => {
  type StateProps = {|
    invalid: boolean,
    onClick?: ?Function,
  |};

  type DispatchProps = {|
    onShowValidationErrors: Function,
    onHideValidationErrors: Function,
  |};

  type Props = StateProps & DispatchProps;

  class WithOnClickValidation extends Component<Props> {
    static defaultProps = {
      onClick: () => {},
    };

    componentWillUnmount() {
      const { onHideValidationErrors } = this.props;
      onHideValidationErrors();
    }


    handleClick = (e: Event) => {
      const {
        onClick,
        invalid,
        onShowValidationErrors,
        onHideValidationErrors,
      } = this.props;

      if (invalid) {
        e.preventDefault();
        return onShowValidationErrors();
      }

      if (onClick && typeof onClick === 'function') {
        onClick(e);
      }

      return onHideValidationErrors();
    }

    render() {
      const {
        invalid,
        onShowValidationErrors,
        onHideValidationErrors,
        onClick,
        ...props
      } = this.props;

      return (
        <WrappedComponent onClick={(e: Event) => this.handleClick(e)} {...props} />
      );
    }
  }

  const mapStateToProps = (state): StateProps => ({
    invalid: useConfigValidation() && anyChoiceGroupHasError(state),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    onShowValidationErrors: () => {
      dispatch(showValidationErrors());
      scrollToAnchor({ block: 'center', anchorId: ERROR_ID });
    },
    onHideValidationErrors: hideValidationErrors,
  });

  return connect(mapStateToProps, mapDispatchToProps)(WithOnClickValidation);
};


export default withOnClickValidation;
